import { render, staticRenderFns } from "./AppDocumentacionAduanera.vue?vue&type=template&id=7b94f222&"
import script from "./AppDocumentacionAduanera.vue?vue&type=script&lang=js&"
export * from "./AppDocumentacionAduanera.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports